import React from "react";

const MoreOptionsHorizontal = React.forwardRef(
  (
    {
      width = "20",
      height = "20",
      viewBox = "0 0 20 20",
      fillColor = "#98A2B3",
      className,
      fill = "none",
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8334 10C10.8334 9.5398 10.4603 9.16671 10 9.16671C9.5398 9.16671 9.16671 9.5398 9.16671 10C9.16671 10.4603 9.5398 10.8334 10 10.8334C10.4603 10.8334 10.8334 10.4603 10.8334 10Z"
          stroke="#98A2B3"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.00004 10C5.00004 9.5398 4.62694 9.16671 4.16671 9.16671C3.70647 9.16671 3.33337 9.5398 3.33337 10C3.33337 10.4603 3.70647 10.8334 4.16671 10.8334C4.62694 10.8334 5.00004 10.4603 5.00004 10Z"
          stroke="#98A2B3"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.6667 10C16.6667 9.5398 16.2936 9.16671 15.8334 9.16671C15.3731 9.16671 15 9.5398 15 10C15 10.4603 15.3731 10.8334 15.8334 10.8334C16.2936 10.8334 16.6667 10.4603 16.6667 10Z"
          stroke="#98A2B3"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
);

export default MoreOptionsHorizontal;
